import React from 'react';

import { animated, config, useSpring } from 'react-spring';
import { LargeArrowRightIcon } from 'src/components/icons/LargeArrowRightIcon';

const AnimatedRightArrowIcon = animated(LargeArrowRightIcon);

interface AnimatedArrowIconProps extends React.HTMLAttributes<HTMLElement> {
  rotated: boolean;
}

export function AnimatedArrowIcon(props: AnimatedArrowIconProps): JSX.Element {
  const { className, rotated } = props;
  const springProps = useSpring({
    config: config.stiff,
    to: {
      transform: rotated ? 'rotate(-90deg)' : 'rotate(90deg)',
    },
  });

  return <AnimatedRightArrowIcon className={className} style={springProps} />;
}
